import { AjaxLoader } from '../../lib/ajax-load-promise.js';

class Glossary {
    constructor () {
        this.$glossary = document.querySelector('[data-glossary="root"]');
        this.$glossaryMain = this.$glossary.querySelector('[data-glossary="main"]');
        this.$glossaryEntrys = this.$glossary.querySelector('[data-glossary="entrys"]');

        // Breadcrumb
        this.$breadcrumb = document.querySelector('[data-breadcrumb="root"]');
        this.$breadcrumbItems = this.$breadcrumb.querySelector('[data-breadcrumb="items"]');
        this.$lastBreadcumbItem = null;
        this.$initialDocumentTitle = document.querySelector('#document_title_initial');
        this.$ajaxDocumentTitle = document.querySelector('#document_title_ajax');

        this.$siteHeader = document.querySelector('[data-site-header]');

        this.editmode = document.body.getAttribute('data-editmode') === '';

        this.glossarySidebarPos = null;
        this.newGlossarySidebarPos = 0;
        this.waiting = false;
        this.contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$glossaryMain
            }
        });

        // Options
        this.initial = document.querySelector('#document_title_ajax') === null;
        this.documentTitle = this.initial ? this.$initialDocumentTitle.value : this.$ajaxDocumentTitle.value;
    }

    initialize () {
        if (this.$breadcrumb && this.$breadcrumbItems) {
            this.updateBreadcrumb();
        }

        this.setEvents();

        const wait = setInterval(() => {
            if (!document.body.classList.contains('has--notransition')) {
                if (window.innerWidth < 768) {
                    this.closeEntrys();
                }

                this.checkDomPosition();
                this.checkScrollPosition(window.pageYOffset);
                clearInterval(wait);
            }
        }, 100);
    }

    closeEntrys () {
        const $checkedEntry = this.$glossaryEntrys.querySelector('input:checked');

        if ($checkedEntry) {
            $checkedEntry.nextElementSibling.click();
        }
    }

    setEvents () {
        if (this.$glossaryEntrys) {
            this.$glossaryEntrys.addEventListener('click', (e) => {
                if (e.target.getAttribute('data-key') !== null) {
                    e.preventDefault();
                    const path = e.target.getAttribute('href');
                    const result = AjaxLoader.getData(path);

                    window.history.replaceState(null, null, path);

                    this.$glossaryEntrys.querySelector('.has--active').classList.remove('has--active');
                    const $label = e.target.closest('ul').parentElement.querySelector('label');

                    $label.classList.add('has--active');
                    this.loadGlossary(result, e.target, () => {
                        if (window.innerWidth < 768) {
                            $label.click();
                        }
                    });
                }
            });

            this.$glossaryEntrys.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.$glossaryEntrys.querySelector('.has--active').classList.add('is--deactive');
                    this.$glossary.classList.add('is--open');
                } else {
                    this.$glossaryEntrys.querySelector('.has--active').classList.remove('is--deactive');
                    this.$glossary.classList.remove('is--open');
                }
            });
        }
    }

    updateBreadcrumb () {
        // Function to build a new breadcrumb item
        const buildBreadcrumbItem = () => {
            // Create a new list item element for the breadcrumb
            this.$lastBreadcumbItem = document.createElement('li');
            // Add the class 'breadcrumb__item' to the new list item
            this.$lastBreadcumbItem.classList.add('breadcrumb__item');
            // Append the new list item to the breadcrumb items container
            this.$breadcrumbItems.appendChild(this.$lastBreadcumbItem);
        };

        // Check if this is the initial state
        if (this.initial) {
            // Set the initial state to false after the first update
            this.initial = false;
        } else {
            // Query the document for the element with ID 'document_title_ajax'
            this.$ajaxDocumentTitle = document.querySelector('#document_title_ajax');
            // Get the value of the queried element
            this.documentTitle = this.$ajaxDocumentTitle.value;

            // Check if the last breadcrumb item does not exist
            if (this.$lastBreadcumbItem === null) {
                // Build a new breadcrumb item if the last one is null
                buildBreadcrumbItem();
            }
        }

        // Set the text content of the last breadcrumb item to the document title
        if (this.$lastBreadcumbItem && this.documentTitle !== '') {
            this.$lastBreadcumbItem.textContent = this.documentTitle;
        }
    }

    loadGlossary (result, entry, callback) {
        result
            .then((results) => {
                results = JSON.parse(results.toString());

                this.setGlossary(results.html, entry, () => {
                    window.dispatchEvent(this.contentUpdateEvent);
                    this.checkForVideo();
                    this.setMeta(results);

                    if (this.$breadcrumb && this.$breadcrumbItems) {
                        this.updateBreadcrumb();
                    }
                });

                if (typeof callback === 'function') {
                    callback();
                }
            });
    }

    checkForVideo () {
        const $youtubeVideos = this.contentUpdateEvent.detail.$context.querySelectorAll('[data-youtube]');

        if ($youtubeVideos.length > 0) {
            import('../../lib/youtube-api-loader').then(({ loadYoutubeApi }) => {
                loadYoutubeApi();
            });

            if (window.youTubeReady !== null) {
                import('../../modules/youtube-player/youtube-player').then(({ YoutubePlayer }) => {
                    const $youtube = new YoutubePlayer($youtubeVideos, window.OPTIONS.breakpoints);
                    $youtube.init();
                });
            } else {
                window.onYouTubeIframeAPIReady = () => {
                    window.youTubeReady = true;
                    import('../..//modules/youtube-player/youtube-player').then(({ YoutubePlayer }) => {
                        const $youtube = new YoutubePlayer($youtubeVideos, window.OPTIONS.breakpoints);
                        $youtube.init();
                    });
                };
            }
        }
    }

    setMeta (results) {
        const $metaURL = document.querySelector('meta[property="og:url"]');
        const $canonical = document.querySelector('link[rel="canonical"]');
        const $metaTitle = document.querySelector('meta[property="og:title"]');
        const $metaHeadline = document.querySelector('meta[name="headline"]');
        const $twitterTitle = document.querySelector('meta[name="twitter:title"]');
        // const $mediaBlockImage = this.$glossaryMain.querySelector('.image-block__image');
        // const $metaImage = document.querySelector('meta[property="og:image"]');
        // let $image = null;

        // if ($mediaBlockImage) {
        //     $image = $mediaBlockImage.querySelector('img');
        // } else {
        //     if ($metaImage) {
        //         $metaImage.remove();
        //     }
        // }
        //
        $metaURL.content = window.location.href;

        if (results.key) {
            if ($metaTitle) {
                $metaTitle.content = results.key;
            }

            if ($twitterTitle) {
                $twitterTitle.content = results.key;
            }

            if ($metaHeadline) {
                $metaHeadline.content = results.key;
            }
        }

        // if ($image) {
        //     if ($metaImage) {
        //         $metaImage.content = $image.src;
        //     } else {
        //         const newMetaImage = document.createElement('meta');
        //         newMetaImage.setAttribute('property', 'og:image');
        //         newMetaImage.content = $image.src;
        //         $metaTitle.parentNode.insertBefore(newMetaImage, $metaTitle.nextSibling);
        //     }
        // }

        $canonical.href = window.location.href;
    }

    setGlossary (content, entry, callback) {
        const snippet = document.createElement('div');
        this.$glossaryEntrys.querySelector('a.is--active').classList.remove('is--active');
        entry.classList.add('is--active');

        snippet.innerHTML = content;

        this.$glossaryMain.innerHTML = snippet.innerHTML;

        if (typeof callback === 'function') {
            callback();
        }
    }

    checkScrollPosition (position) {
        if (!this.editmode && window.innerWidth < 768) {
            this.newGlossarySidebarPos = this.glossarySidebarPos;

            if (position >= this.newGlossarySidebarPos && this.newGlossarySidebarPos !== null) {
                this.$glossaryEntrys.classList.add('is--fixed');

                if (this.$siteHeader.classList.contains('is--visible')) {
                    this.$glossaryEntrys.style.top = '60px';
                } else if (this.$siteHeader.classList.contains('is--hidden') || (this.$siteHeader.classList.contains('is--fixed') && !this.$siteHeader.classList.contains('is--hidden'))) {
                    this.$glossaryEntrys.style.top = '0';
                }

                if (position >= (this.$glossaryMain.offsetTop + this.$glossaryMain.clientHeight)) {
                    this.$glossaryEntrys.classList.remove('is--fixed');
                    this.$glossaryEntrys.style.top = '';
                }
            } else if (position < this.newGlossarySidebarPos) {
                if (this.$siteHeader.classList.contains('is--visible')) {
                    if (position < (this.newGlossarySidebarPos - 60)) {
                        this.$glossaryEntrys.classList.remove('is--fixed');
                        this.$glossaryEntrys.style.top = '';
                    }
                } else {
                    if (position < (this.newGlossarySidebarPos)) {
                        this.$glossaryEntrys.classList.remove('is--fixed');
                        this.$glossaryEntrys.style.top = '';
                    }
                }
            }
        } else {
            if (this.$glossaryEntrys.classList.contains('is--fixed')) {
                this.$glossaryEntrys.classList.remove('is--fixed');
            }
        }
    }

    checkDomPosition () {
        if (!this.editmode && window.innerWidth < 768) {
            if (this.$glossaryEntrys.classList.contains('is--fixed')) {
                this.$glossaryEntrys.classList.remove('is--fixed');
            }
            this.glossarySidebarPos = this.$glossary.offsetTop + 1;
        }
    }
}

export { Glossary };
